module.exports = __webpack_public_path__ + "static/media/DSC_0020.8bf143df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0020.jpg
// module id = 676
// module chunks = 0